export const BORDER = {
    borderTop: null,
    borderBottom: null,
    borderRight: null,
    borderLeft: null,
    borderRadius: 0
};
export const PADDING = {
    paddingTop: 0,
    paddingBottom: 0,
    paddingRight: 0,
    paddingLeft: 0
};
export const MARGIN = {
    marginBottom: 0,
    marginTop: 0,
    marginRight: 0,
    marginLeft: 0
};
